import { render, staticRenderFns } from "./ProfileTile.vue?vue&type=template&id=0584f13d&"
import script from "./ProfileTile.vue?vue&type=script&lang=js&"
export * from "./ProfileTile.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports